
const assetFiles = import.meta.glob(
  ["/src/assets/industries/*", "/src/assets/services/*"],
  { eager: true, query: "?url", import: "default" }
);

const byName = {};
for (const [path, url] of Object.entries(assetFiles)) {
  const name = path
    .split("/")
    .pop()
    .replace(/\.[^.]+$/, "")
    .toLowerCase();
  if (!byName[name]) byName[name] = url;
}

// Images used inside blog article bodies, hosted in src/assets/blogs/.
// File names are <blog #><letter>.webp, in the order the images appear in the article.
const blogFiles = import.meta.glob("/src/assets/blogs/*", {
  eager: true,
  query: "?url",
  import: "default",
});

const byBlogName = {};
for (const [path, url] of Object.entries(blogFiles)) {
  const name = path.split("/").pop().replace(/\.[^.]+$/, "").toLowerCase();
  byBlogName[name] = url;
}

// Article HTML in blog.js references images by local key ("1a", "14c", ...).
// Returns the hosted file URL, or "" if src/assets/blogs/<key>.* does not exist.
export const getContentImage = (key = "") => byBlogName[String(key).toLowerCase()] || "";

// Media cards: src/assets/media/<key>.* (key is the `image` value in media.js)
const mediaFiles = import.meta.glob("/src/assets/media/*", {
  eager: true,
  query: "?url",
  import: "default",
});

const byMediaName = {};
for (const [path, url] of Object.entries(mediaFiles)) {
  const name = path.split("/").pop().replace(/\.[^.]+$/, "").toLowerCase();
  byMediaName[name] = url;
}

export const getMediaImage = (key = "") => byMediaName[String(key).toLowerCase()] || "";

export const getAssetImage = (name = "") => byName[name.toLowerCase()] || "";

export const getBlogImage = (post) => {
  const image = post?.image || "";
  return /^(https?:)?\/\//.test(image) ? image : getAssetImage(image);
};

export const BLOG_HERO_IMAGE = getAssetImage("da-hero");

export const MEDIA_HERO_IMAGE = getAssetImage("hero");
